var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"5px"}},[_c('div',{attrs:{"id":"content"}},[_c('img',{attrs:{"src":_vm.cover,"width":"150px","height":"90px"}}),_c('p',[_vm._v(_vm._s(_vm.title))])])])}
var staticRenderFns = []

export { render, staticRenderFns }